import { render, staticRenderFns } from "./warehouseService.vue?vue&type=template&id=3952b284&scoped=true&"
import script from "./warehouseService.vue?vue&type=script&lang=js&"
export * from "./warehouseService.vue?vue&type=script&lang=js&"
import style0 from "./warehouseService.vue?vue&type=style&index=0&id=3952b284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3952b284",
  null
  
)

export default component.exports